import React from "react";
import { motion } from "framer-motion";
import { FaDumbbell, FaBullseye, FaChartLine, FaClock } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const TrainingPage = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: <FaBullseye className="w-6 h-6" />,
      title: t("training.features.precisionTraining.title"),
      description: t("training.features.precisionTraining.description"),
    },
    {
      icon: <FaChartLine className="w-6 h-6" />,
      title: t("training.features.progressTracking.title"),
      description: t("training.features.progressTracking.description"),
    },
    {
      icon: <FaClock className="w-6 h-6" />,
      title: t("training.features.timeManagement.title"),
      description: t("training.features.timeManagement.description"),
    },
  ];

  return (
    <div className="min-h-screen  py-20 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="bg-test/20 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-8">
            <FaDumbbell className="w-10 h-10 text-test" />
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-test mb-6">
            {t("training.title")}
          </h1>

          <p className="text-xl text-white/80 mb-12 leading-relaxed">
            {t("training.description")}
          </p>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-secondary/50 backdrop-blur-sm rounded-xl p-6 border border-test/10 flex flex-col min-h-[200px]"
              >
                <div className="bg-test/10 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 text-test flex-shrink-0">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-semibold text-test mb-3 flex-shrink-0 break-words hyphens-auto">
                  {feature.title}
                </h3>
                <p className="text-white/70 flex-grow break-words leading-relaxed">
                  {feature.description}
                </p>
              </motion.div>
            ))}
          </div>

          <div className="bg-secondary/30 backdrop-blur-sm rounded-xl p-8 border border-test/10">
            <h2 className="text-2xl font-semibold text-test mb-6">
              {t("training.whatToExpect.title")}
            </h2>
            <div className="text-left space-y-4 text-white/80">
              <p>{t("training.whatToExpect.features.personalizedPlans")}</p>
              <p>{t("training.whatToExpect.features.interactiveDrills")}</p>
              <p>{t("training.whatToExpect.features.realTimeFeedback")}</p>
              <p>{t("training.whatToExpect.features.progressTracking")}</p>
              <p>{t("training.whatToExpect.features.trainingSchedules")}</p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TrainingPage;
